var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user.id)?_c('div',[_c('panel')],1):_c('div',[_c('front')],1)}
var staticRenderFns = []

export { render, staticRenderFns }